window.bootstrap = require('./bootstrap');
